<!--
/**
* @name: List.vue
* @description: 操作日志
* @author: 于海威
* @create: 2020/08/07 18:05:38
* @update: 2020/08/07 18:05:38
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query @search="onSearch"
      spaceBetween
      searchText="查询">
      <y-query-item>
        <k-input placeholder="请输入用户账号"
          clearable
          v-model="para.usernameOrName"></k-input>
      </y-query-item>
      <y-query-item>
        <!-- <k-select placeholder="请选择操作类型">
          <k-option></k-option>
        </k-select> -->
        <k-input placeholder="请输入操作类型"
          clearable
          v-model="para.description"></k-input>
      </y-query-item>
      <y-query-item slot="append">
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="logList"
      :height="$root.tableHeightXX"
      :rightFixedNumber="1"
      :columns="initColumns()"></k-table>
    <k-pagination v-if="logList && logList.length"
      :total="total"
      :current-page.sync="para.pageCurrent"
      :page-size.sync="para.pageSize"
      @page-change="onChangePageIndex" />
    <k-popup title="操作内容"
      :show.sync="isShowDetail"
      layout="header, body, close, mask">
      <y-popup-body size="small">
        <div :class="css.detail">
          <div>ID: {{editPara.id}}</div>
          <div>用户信息: <insensitive :val="editPara.username"></insensitive> / {{editPara.realName}}</div>
          <div>具体操作内容:</div>
          <div :class="css.detail_content">{{editPara.content}}</div>
        </div>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>

<script>
import {
  // NESTLE_SYSTEM_BACK_SERVER_SYSTEM_LOG_DETAIL,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_LOG_PAGE
  // NESTLE_SYSTEM_BACK_SERVER_SYSTEM_LOG_SAVE
} from '@/assets/modules/apiList';

const initPara = () => ({
  description: '',
  pageCurrent: 1,
  pageSize: 15,
  resourceCode: '',
  resourceName: '',
  usernameOrName: ''
});
export default {
  data() {
    return {
      logList: [],
      total: 0,
      para: initPara(),
      isShowDetail: false,
      isLoading: false,
      editPara: {}
    };
  },
  watch: {
    isShowDetail(v) {
      if (!v) {
        this.editPara = {};
      }
    }
  },
  methods: {
    initColumns() {
      return [
        {
          name: 'ID',
          field: 'id',
          style: {
            width: 50
          }
        },
        {
          name: '操作时间',
          field: 'createTime',
          style: {
            wdith: 80
          }
        },
        {
          name: '用户信息',
          field: 'realName',
          style: {
            width: 60
          },
          customRender: (row) => (
            <div class={this.css.table_cell}>
              <p>{row.realName}</p>
              <p><insensitive val={row.username} isShowEye={false}></insensitive></p>
            </div>
          )
        },
        {
          name: '组织机构',
          field: '',
          style: {
            wdith: 100
          }
        },
        {
          name: '操作类型',
          field: 'description',
          style: {
            width: 60
          }
        },
        {
          name: '操作模块',
          field: 'resourceName',
          style: {
            width: 120
          }
        },
        {
          name: '操作内容',
          field: 'resourceCode',
          style: {
            width: 90
          }
        },
        {
          name: '操作',
          customRender: row => {
            const viewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                详情
              </a>
            );
            return <div>{viewButton}</div>;
          },
          style: {
            width: 60
          }
        }
      ];
    },
    onView(row) {
      this.isShowDetail = true;
      this.editPara = JSON.parse(JSON.stringify(row));
    },
    onReset() {
      this.para = initPara();
      this.getLogList();
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getLogList();
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getLogList();
    },
    getLogList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_LOG_PAGE,
        para: this.para
      }).then(res => {
        this.logList = res.pageList;
        this.total = res.total;
      });
    }
  },
  created() {
    this.getLogList();
  }
};
</script>

<style lang="postcss" module="css">
.detail {
  line-height: 200%;
  & .detail_content {
    margin-top: 10px;
    margin-bottom: 15px;
    border: solid 1px var(--color-border);
    border-radius: 4px;
    padding: 10px;
    min-height: 180px;
  }
}
.table_cell {
  padding: 5px 0;
  line-height: 150%;
}
</style>
